import React, { Component } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { Text, Box, Card, CardHeader, CardBody, Spacer } from '@chakra-ui/react';

import ConfigService from "../../services/ConfigService";
import CoreService from "../../services/CoreService";
import NotificationService from "../../services/NotificationService";

import SubscriberMgmtButtonPanel from "./Components/SubscriberMgmtButtonPanel";
import SubscriberGrid from "./Components/SubscriberGrid";
import SubscriberRulesPanel from "./Components/SubscriberRulesPanel";
import ModalSubscriberDialog from "./Components/ModalSubscriberDialog";


import SubscriptionManager from "../../managers/SubscriptionManager";



const DelSwal = withReactContent(Swal);


export default class SubscriberManagementPage extends Component {
  constructor(props) {
    super(props);

    this.configService = new ConfigService();
    this.coreService = new CoreService();
    this.notificationService = new NotificationService();

    this.syncTimer = null;



    this.state = {
      showDialog: false,
      editMode: "add",
      subscriberData: null,
      currentSubscriber: null,
      isStatusActive: null,
      isLoadingGrid: false,
      currentSubscriptionId: "ErrorResult", // the only one we currently support
      subscriptionOrgSchema: null
    };

    this.refreshData = this.refreshData.bind(this);


    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onNewSubscriberRequest = this.onNewSubscriberRequest.bind(this);
    this.onEditSubscriberRequest = this.onEditSubscriberRequest.bind(this);
    this.onDeleteSubscriberRequest = this.onDeleteSubscriberRequest.bind(this);
    this.onBtnToggleRetireSelectedSubscriber = this.onBtnToggleRetireSelectedSubscriber.bind(this);
    this.onSendTestMessageRequest = this.onSendTestMessageRequest.bind(this);

    this.closeModal = this.closeModal.bind(this);
    this.postNew = this.postNew.bind(this);
    this.postUpdated = this.postUpdated.bind(this);



  }

  async componentDidMount() {
    await this.refreshData();
  }




  async refreshData() {
    this.setState({ isLoadingGrid: true });
    var gridDataResponse = await this.coreService.fetchSubscriberList(this.props.userSession.gcid, this.props.userSession.token, true);
    if (gridDataResponse.hasError) {
      this.props.onErrorPageRequest("Problem fetching Subscribers.");
      return;
    }
    var dataResult = gridDataResponse.dataResult;
    var existingNames = dataResult.map((d) => {return d.name});
    this.setState({
      subscriberData: dataResult,
      existingNames: existingNames,
      selectedRow: null, // reset
      isLoadingGrid: false
    });
  }





  onRowSelectChange(newSelectedRow) {
    console.log("OnRowSelectChange");
    console.log("set state for selectedRow");
    console.info(newSelectedRow);
    var isStatusActive = newSelectedRow.isActive;
    this.setState({
      currentSubscriber: newSelectedRow,
      isStatusActive: isStatusActive
    });
  }

  onNewSubscriberRequest() 
  {
    this.setState({
      editMode: "add",
      showDialog: true
    });
  }

  onEditSubscriberRequest() 
  {
    if (!this.state.currentSubscriber) {
      DelSwal.fire({ icon: "error", title: "Edit Subscriber", text: "Select a subscriber first!" });
      return;
    }
    this.setState({
      editMode: "update",
      showDialog: true
    });
  }

  closeModal() 
  {
    this.setState({ showDialog: false })
  }

  async postNew(subscriber) 
  {
    try
    {
      var result = await this.coreService.postSubscriber(subscriber, this.props.userSession.gcid, this.props.userSession.token);
      if (result.hasError) {
        toast.error("Problem posting new subscriber.");
        return;
      }
      toast.success("New subscriber " + subscriber.name + " has been added.");
      await this.refreshData();
    }
    finally
    {
      this.closeModal();
    }

  }



  async postUpdated(subscriber) 
  {    
    try
    {
      var result = await this.coreService.postSubscriber(subscriber, this.props.userSession.gcid, this.props.userSession.token);
      if (result.hasError) {
        toast.error("Problem updating subscriber.");
        return;
      }
      toast.success("subscriber " + subscriber.name + " has been updated.");
      await this.refreshData();
    }
    finally{
      this.closeModal();
    }
  }

  async onDeleteSubscriberRequest() 
  {
    if (!this.state.currentSubscriber) {
      DelSwal.fire({ icon: "error", title: "Remove Subscriber", text: "Select a subscriber to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove Subscriber?",
          text: "Confirm you want to permanently remove the existing subscriber? " + this.state.currentSubscriber.name,
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          var deleteResponse = await this.coreService.removeSubscriber(this.state.currentSubscriber.id, this.props.userSession.gcid, this.props.userSession.token);
          if (deleteResponse.hasError)
          {
            return DelSwal.fire({ icon: "error", text: currentSubscriberName + " could not be permanently deleted. "+ deleteResponse.messages[0] });
          }
          await this.refreshData();
          var currentSubscriberName = this.state.currentSubscriber.name;
          this.setState({ currentSubscriber: null });
          return DelSwal.fire({ icon: "success", text: currentSubscriberName + " has been permanently deleted." });
        }
      }
      );
  }

  async onBtnToggleRetireSelectedSubscriber() 
  {
    var statusWord = (this.state.isStatusActive) ? "retire" : "activate";
    if (!this.state.currentSubscriber) {
      DelSwal.fire({ icon: "error", title: "Toggle Subscriber", text: "Select a subscriber first!" });
      return;
    }
    var name = this.state.currentSubscriber.name;
    DelSwal.fire({
      icon: "question",
      title: statusWord + " Subscriber?",
      text: "Confirm you want to " + statusWord + " subscriber " + name,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel"
    })
      .then(async (result) => {
        if (result.value) 
        {
          //return DelSwal.fire({ icon: "error", text: "Not yet available for event subscribers." });
          var subscriber = this.state.currentSubscriber;
          subscriber.isActive = (statusWord === "activate"); 
          var postResult = await this.coreService.postSubscriber(subscriber, "", "", this.props.userSession.gcid, this.props.userSession.token);
          if (postResult.hasError) {
          return DelSwal.fire({ icon: "error", text: "there was a problem attempting to " + statusWord + " " + subscriber.name });
          }
          else {
            await this.refreshData();
            this.setState({ currentUser: null });
           return DelSwal.fire({ icon: "success", text: subscriber.name + " has been " + statusWord + "d." });
          }
        }
      });
  }

  async onSendTestMessageRequest()
  {
    if (!this.state.currentSubscriber) {
      DelSwal.fire({ icon: "error", title: "Send Test Message", text: "Select a subscriber first!" });
      return;
    }

    try
    {
      var testResult = this.coreService.postSubscriberNotificationTestMessages(this.state.currentSubscriber, this.props.userSession.gcid, this.props.userSession.token);
      if (testResult.hasError)
      {
        return DelSwal.fire({ icon: "error", text: "there was a problem attempting to send Test Message to " + this.state.currentSubscriber.subscriber.name + "(" + testResult.messages + ")"});
      }
      else 
      {
        return DelSwal.fire({ icon: "success", text: "Test Messages were sent to " + this.state.currentSubscriber.name });
      }
    }
    catch(e)
    {

      DelSwal.fire({ icon: "error", title: "Send Test Message", text: e.message});
    }

  }



  render() {

    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );


    return (

      <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding="20px">

        <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Subscriber Maintenance</Text>
        <Spacer />
        {loadingGridIcon}


          <ModalSubscriberDialog
            showSubscriberModal={this.state.showDialog}
            closeSubscriberModal={this.closeModal}
            postNew={this.postNew}
            postUpdated={this.postUpdated}
            userSession={this.props.userSession}
            editMode={this.state.editMode}
            currentSubscriber={this.state.currentSubscriber}
            currentSubscriptionId={this.state.currentSubscriptionId}
            subscriptionOrgSchema={this.state.subscriptionOrgSchema}
            existingNames={this.state.existingNames}
          />


        <SubscriberMgmtButtonPanel
          isStatusActive={this.state.isStatusActive}
          refreshData={this.refreshData}
          onNewSubscriberRequest={this.onNewSubscriberRequest}
          onEditSubscriberRequest={this.onEditSubscriberRequest}
          onDeleteSubscriberRequest={this.onDeleteSubscriberRequest}
          onBtnToggleRetireSelectedSubscriber={this.onBtnToggleRetireSelectedSubscriber}
          onPostNew={this.postNew}
          onPostUpdated={this.postUpdated}
          onSendTestMessageRequest={this.onSendTestMessageRequest}
        />

        <SubscriberGrid
          rowData={this.state.subscriberData}
          onRowSelectChange={this.onRowSelectChange}
          onEditSubscriberRequest={this.onEditSubscriberRequest}
        />
        {/*
        <SubscriberRulesPanel
          currentSubscriber={this.state.currentSubscriber}
        />
    */}



      </Box>
    );
  }
}
